import { Boundaries } from "@planzone/core";
import { Identifiable, Task } from "@planzone/dto";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function handleMarkTaskAsCompletedRequest(
  task: Identifiable<Task>,
  req: Boundaries["markTaskAsCompleted"]["request"],
): Identifiable<Task> {
  return task.uuid === req.task.uuid
    ? {
        ...task,
        percentComplete: 100,
        completionDate: req.completionDate,
        allocations: task.allocations.map((a) => ({
          ...a,
          percentComplete: 100,
        })),
      }
    : task;
}

function handleMarkTaskAsCompletedSucceeded(
  task: Identifiable<Task>,
  {
    impactedElements,
    task: t,
    completionDate,
  }: Boundaries["markTaskAsCompleted"]["success"],
): Identifiable<Task> {
  const impactedTask = impactedElements
    ? impactedElements.find(({ uuid }) => uuid === task.uuid)
    : undefined;

  return task.uuid === t.uuid
    ? {
        ...task,
        percentComplete: 100,
        completionDate: completionDate,
        allocations: task.allocations.map((a) => ({
          ...a,
          percentComplete: 100,
        })),
      }
    : !!impactedTask
      ? calculateAdvancement({ ...task, ...impactedTask })
      : task;
}

function handleMarkTaskAsCompletedFailure(
  task: Identifiable<Task>,
  req: Boundaries["markTaskAsCompleted"]["failure"],
): Identifiable<Task> {
  return task.uuid === req.task.uuid ? { ...task, ...req.task } : task;
}

export {
  handleMarkTaskAsCompletedRequest,
  handleMarkTaskAsCompletedSucceeded,
  handleMarkTaskAsCompletedFailure,
};
